import { useOpenTiptapSelectionPopup } from '../../popup/useOpenTiptapSelectionPopup';

export const useOpenEmojiPopup = (): (() => void) => useOpenTiptapSelectionPopup('emoji');
